// Shared picker/preview thumbnail helper (Task #1875). Product photos can be
// 17–22 MB originals; rendering them as 28px picker avatars downloads and
// decodes hundreds of MB. Route remote https images through the server-side
// resize proxy (/api/img-proxy — local + R2 cached webp) at a small width so
// picker options load in KBs. Non-https values (data:, blob:, relative
// /uploads paths) are returned untouched — the proxy only accepts https, and
// local paths are already served directly. If the proxy errors for a host
// outside its allow-list, callers fall back to the original URL via
// onError (see thumbFallback).
export function thumbUrl(url: string | null | undefined, w = 64): string | null {
  if (!url) return null;
  if (!/^https:\/\//i.test(url)) return url;
  return `/api/img-proxy?url=${encodeURIComponent(url)}&w=${w}`;
}

// onError handler: if the proxied thumbnail fails (e.g. host not on the
// server allow-list), gracefully fall back to the original full-size URL
// once instead of showing a broken image.
export function thumbFallback(originalUrl: string | null | undefined) {
  return (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    // Callers sometimes hand us a null/undefined (or otherwise non-string)
    // URL — e.g. an option with no image whose thumbnail errored. Guard so
    // the error handler itself never throws.
    if (typeof originalUrl !== "string") return;
    if (img.src !== originalUrl && originalUrl.startsWith("https://")) {
      img.src = originalUrl;
    }
  };
}
